import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";

// import CounterReducer from "../reducers/CounterReducer";
import rootReducer from "../reducers/RootReducer";

const middlewares = [thunkMiddleware];
const middlewareEnhancer = applyMiddleware(...middlewares);

const enhancers = [middlewareEnhancer];
const composeEnhancers =
    process.env.NODE_ENV === "development"
        ? composeWithDevTools
        : (...args) => args[0];
const composedEnhancers = composeEnhancers(...enhancers);

export default function Store(previousState) {
    const store = createStore(
        rootReducer,
        previousState,
        composedEnhancers
        //   window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
    );
    return store;
}